// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3bRqz","column":"style_column__1izHf","fullBleede":"style_fullBleede__3tIYp","bounce":"style_bounce__1yPgr"};